import SectionCard from "@/components/base/SectionCard";
import type { DocumentStatus, StoreDocument } from "@/types";

interface StoreDocumentsCardProps {
  documents: StoreDocument[];
  onReupload: (key: string) => void;
}

const STATUS_CONFIG: Record<
  DocumentStatus,
  { label: string; icon: string; className: string }
> = {
  approved: {
    label: "معتمد",
    icon: "ri-checkbox-circle-fill",
    className: "bg-primary-100 text-primary-800",
  },
  review: {
    label: "قيد المراجعة",
    icon: "ri-time-line",
    className: "bg-accent-100 text-accent-900",
  },
  rejected: {
    label: "مرفوض",
    icon: "ri-close-circle-fill",
    className: "bg-red-100 text-red-600",
  },
};

export default function StoreDocumentsCard({
  documents,
  onReupload,
}: StoreDocumentsCardProps) {
  return (
    <SectionCard
      title="المستندات الرسمية"
      subtitle="حالة التحقق من أوراق المحل لدى الإدارة"
      icon="ri-file-shield-2-line"
      iconClass="bg-secondary-200 text-secondary-800"
    >
      {documents.length === 0 ? (
        <div className="rounded-box border border-dashed border-background-300 px-4 py-10 text-center">
          <div className="mx-auto w-12 h-12 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-3">
            <i className="ri-file-shield-2-line text-xl"></i>
          </div>
          <p className="text-sm text-foreground-500">
            لا توجد مستندات مرفوعة بعد.
          </p>
        </div>
      ) : (
        <ul className="space-y-2.5">
          {documents.map((doc) => {
            const config = STATUS_CONFIG[doc.status];
            return (
              <li
                key={doc.key}
                className="rounded-btn border border-background-200 px-4 py-3"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="text-sm font-medium text-foreground-800">
                    {doc.label}
                  </span>
                  <span
                    className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${config.className}`}
                  >
                    <i className={config.icon}></i>
                    {config.label}
                  </span>
                </div>

                {doc.status === "rejected" && doc.rejectReason && (
                  <div className="mt-2.5">
                    <p className="text-xs leading-6 text-red-600">
                      سبب الرفض: {doc.rejectReason}
                    </p>
                    <button
                      type="button"
                      onClick={() => onReupload(doc.key)}
                      className="mt-2 inline-flex items-center gap-1.5 h-9 rounded-btn bg-red-50 px-3 text-xs font-semibold text-red-600 hover:bg-red-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-upload-2-line"></i>
                      إعادة الرفع
                    </button>
                  </div>
                )}

                {doc.status === "review" && (
                  <p className="mt-2 text-xs leading-6 text-foreground-500">
                    مستندك قيد المراجعة من الإدارة، وسنُشعرك بالنتيجة عند الانتهاء.
                  </p>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </SectionCard>
  );
}